export default "__VITE_ASSET__1e27ac29__"